import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ACTIONS from "../../../../redux/action";
import i18n from "../../../../utils/i18n";
import QuickResultProviderCarousel from "./QuickResultProviderCarousel.jsx";
import {
  countAspQuickResultProviders,
  isGroupedProviderTiers,
  pickTopQuickResultProviders,
} from "./quickResultProviders";
import classes from "./quickResultStep.module.scss";

const QuickResult = () => {
  const dispatch = useDispatch();
  const [companyStore, potentialProviders] = useSelector((state) => [
    state.company_store,
    state.company_store.potential_providers,
  ]);

  const providerCount = useMemo(() => {
    if (companyStore.potProvMatchingCount != null) {
      return companyStore.potProvMatchingCount;
    }
    return countAspQuickResultProviders(potentialProviders);
  }, [companyStore.potProvMatchingCount, potentialProviders]);

  const topProviders = useMemo(
    () => pickTopQuickResultProviders(potentialProviders, 9),
    [potentialProviders],
  );

  const hasProviderData = isGroupedProviderTiers(potentialProviders);
  const filteredOutCount = companyStore.potProvFilteredOutCount ?? 0;

  useEffect(() => {
    if (!hasProviderData) {
      return;
    }
    if (companyStore.potProvCount !== providerCount) {
      dispatch(
        ACTIONS.addCompanyInfo({
          id: "potProvCount",
          data: providerCount,
          stateObject: "company_store",
        }),
      );
    }
  }, [companyStore.potProvCount, dispatch, hasProviderData, providerCount]);

  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.quickresultheadline1")}{" "}
                <span className={classes.highlight}>
                  {providerCount} {i18n.t("searchflow.accountantnoun")}
                </span>{" "}
                {i18n.t("searchflow.matchesyouranswers")}
              </h1>
              <p className={classes.subtitle}>
                {`${i18n.t("searchflow.quickresultsubtitle1")} ${filteredOutCount} `}
                {i18n.t("searchflow.quickresultsubtitle2")}
              </p>
            </header>
          </div>

          <div className={classes.carouselSection}>
            <div
              className={`${classes.body} ${topProviders.length > 0 ? classes.bodyWithCarousel : ""}`}
            >
              {topProviders.length > 0 ? (
                <QuickResultProviderCarousel
                  providers={topProviders}
                  selectedIndustry={companyStore.industry}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickResult;
